import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ArticleGrid from "./components/ArticleGrid";
import About from "./components/About";
import CtaSection from "./components/CtaSection";
import Testimonial from "./components/Testimonial";
import PageMeta, { getSiteUrl } from "@/components/feature/PageMeta";

const siteUrl = getSiteUrl();

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      url: siteUrl,
      name: "Hipobuy Spreadsheet",
      description:
        "Guide complet du hipobuy spreadsheet 2026. Optimisez votre système hipobuy avec notre outil de tracking spécialisé.",
      inLanguage: "fr",
      publisher: {
        "@id": `${siteUrl}/#organization`,
      },
    },
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      name: "Hipobuy.yachts",
      url: siteUrl,
      address: {
        "@type": "PostalAddress",
        streetAddress: "128 Rue de la Paix",
        addressLocality: "Paris",
        postalCode: "75002",
        addressCountry: "FR",
      },
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+33-1-45-67-89-10",
        email: "contact@hipobuy.yachts",
        contactType: "customer service",
        availableLanguage: "French",
      },
      sameAs: [
        "https://twitter.com/hipobuy",
        "https://linkedin.com/company/hipobuy",
        "https://instagram.com/hipobuy",
        "https://facebook.com/hipobuy",
      ],
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      url: siteUrl,
      name: "Hipobuy Spreadsheet : Guide Complet 2026 | Optimisez Votre Système",
      description:
        "Découvrez le guide complet du hipobuy spreadsheet 2026. Apprenez à optimiser votre système hipobuy, automatiser vos processus et améliorer vos résultats.",
      isPartOf: { "@id": `${siteUrl}/#website` },
      about: { "@id": `${siteUrl}/#organization` },
      inLanguage: "fr",
    },
  ],
};

export default function Home() {
  return (
    <>
      <PageMeta
        title="Hipobuy Spreadsheet : Guide Complet 2026 | Optimisez Votre Système"
        description="Découvrez le guide complet du hipobuy spreadsheet 2026. Apprenez à optimiser votre système hipobuy, automatiser vos processus et améliorer vos résultats avec notre outil de tracking spécialisé."
        keywords="hipobuy spreadsheet, guide hipobuy, outil hipobuy, optimisation spreadsheet, tracking hipobuy, spreadsheet guide 2026"
        canonicalUrl={siteUrl}
        ogTitle="Hipobuy Spreadsheet : Guide Complet 2026 | Optimisez Votre Système"
        ogDescription="Découvrez le guide complet du hipobuy spreadsheet 2026. Apprenez à optimiser votre système hipobuy et automatiser vos processus."
        ogUrl={siteUrl}
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="Hipobuy Spreadsheet : Guide Complet 2026"
        twitterDescription="Guide complet du hipobuy spreadsheet pour optimiser votre système et automatiser vos processus."
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ArticleGrid />
        <About />
        <CtaSection />
        <Testimonial />
      </main>
      <Footer />
    </>
  );
}